import { useTranslation } from 'react-i18next';

const features = [
  { icon: 'ri-list-check', titleKey: 'features.feature_1_title', descKey: 'features.feature_1_desc' },
  { icon: 'ri-user-search-line', titleKey: 'features.feature_2_title', descKey: 'features.feature_2_desc' },
  { icon: 'ri-shield-check-line', titleKey: 'features.feature_3_title', descKey: 'features.feature_3_desc' },
  { icon: 'ri-truck-line', titleKey: 'features.feature_4_title', descKey: 'features.feature_4_desc' },
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              {t('features.title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {features.map((f) => (
              <div
                key={f.titleKey}
                className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-3 md:mb-4">
                  <i className={`${f.icon} text-lg md:text-xl`} />
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {t(f.titleKey)}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {t(f.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}